import { ResultSet } from "../../../../../../API/fields";

export function filterResultSetsByLastCalibrated(
  resultSets: ResultSet[],
): ResultSet[] {
  const latestCalibratedBySource = new Map<string, ResultSet>();
  for (const resultSet of resultSets) {
    if (resultSet.calibration != null) {
      const sourceId = resultSet.calibration.source_result_set_id;
      const current = latestCalibratedBySource.get(sourceId);
      if (!current || resultSet.created_at > current.created_at) {
        latestCalibratedBySource.set(sourceId, resultSet);
      }
    }
  }

  return resultSets.filter((resultSet) => {
    if (resultSet.calibration == null) {
      return !latestCalibratedBySource.has(resultSet.id);
    }
    return (
      latestCalibratedBySource.get(resultSet.calibration.source_result_set_id)
        ?.id === resultSet.id
    );
  });
}
